<template>
    <div >
        <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">

                        <el-form-item label="客户名称或编码" prop="customerLike">
                            <el-input v-model="q.customerLike" placeholder="请输入客户名称或编码"></el-input>
                        </el-form-item>
                        <el-form-item label="销售区域" class="h-elformWrap-2" prop="saleareaCode">
                            <brselect category="YlSalesArea_chanpin" :v="q.saleareaCode" v-model="q.saleareaCode" clearable
                                      @change="changeArea($event)"
                                      style="width:100%"/>
                        </el-form-item>

                        <el-form-item label="销售地市" prop="salesCity">
                            <el-select
                                :clearable="true"
                                v-model="q.salesCity"
                                style="width: 100%"
                                :v="q.salesCity">
                                <el-option v-for="item in salesCityList"
                                           :key="item.index"
                                           :value="item.code"
                                           :label="item.name"
                                ></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="是否计算返利" class="h-elformWrap-2" prop="jiSuan">
                            <brselect
                                style="width:2rem"
                                category="shifou_keyong"
                                :v="q.jiSuan"
                                v-model="q.jiSuan"
                                clearable placeholder="--请选择--">
                            </brselect>
                        </el-form-item>


                        <el-form-item label="销售渠道" class="h-elformWrap-2" prop="qudaoList">
                            <brselect :multiple="true" category="sales_region_ct"
                                      :v="q.qudaoList"
                                      v-model="q.qudaoList"
                                      :clearable="true"
                            />

                        </el-form-item>


                    </div>
                </el-form>
                <div class="l-screenBox">

                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>

                    </div>
                </div>
            </div>

            <div class="h-table h-mrt30">
                <el-table
                    ref="ddtable"
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    :summary-method="getSummaries"
                    show-summary
                    stripe
                    border
                    style="width: 100%">
                    <el-table-column
                        label="序号"t
                        type="index"
                        width="50px"
                        fixed>
                    </el-table-column>
                    <!-- 固定左侧客户信息 -->

                    <el-table-column prop="saleareaName" label="销售区域" width="100"></el-table-column>
                    <el-table-column prop="salesCityName" label="销售城市" width="100"></el-table-column>

                   <el-table-column label="城市类型"
                                     class="h-elformWrap-2"
                                     prop="cityType"
                                     width="100"
                                     :show-overflow-tooltip="true" >
                        <template slot-scope="scope">
                            {{scope.row.cityType | dictname('city_type')}}
                        </template>
                    </el-table-column>


                    <el-table-column prop="customerCode" label="客户编码" width="100"></el-table-column>
                    <el-table-column prop="customerName" label="客户名称" width="180"></el-table-column>
                    <el-table-column label="销售渠道"
                                     class="h-elformWrap-2"
                                     prop="salechannelCode"
                                     width="100"
                                     :show-overflow-tooltip="true"
                                     >
                        <template slot-scope="scope">
                            {{scope.row.salechannelCode | dictname('sales_region_ct')}}
                        </template>
                    </el-table-column>


                    <el-table-column prop="yewuname" label="业务员"   :show-overflow-tooltip="true"width="80"></el-table-column>
                    <el-table-column prop="phone" label="联系电话"    :show-overflow-tooltip="true" width="110"></el-table-column>


                    <el-table-column label="1月安装金额" align="center">
                        <el-table-column prop="lastYear1Amt" label="同期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column prop="currYear1Amt" label="当期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column  prop="standard1"    label="是否达标"   width="80"      >
                            <template slot-scope="scope">
                                <span :style="{ color: getStandardColor(scope.row.standard1) }">
                                  {{ formatStandard(scope.row.standard1) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reward1" label="奖励金额(元)" width="80" align="right" ></el-table-column>
                    </el-table-column>


                    <el-table-column label="2月安装金额" align="center">
                        <el-table-column prop="lastYear2Amt" label="同期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column prop="currYear2Amt" label="当期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column  prop="standard2"    label="是否达标"   width="80"      >
                            <template slot-scope="scope">
                                <span :style="{ color: getStandardColor(scope.row.standard2) }">
                                  {{ formatStandard(scope.row.standard2) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reward2" label="奖励金额(元)" width="80" align="right" ></el-table-column>
                    </el-table-column>


                    <el-table-column label="3月安装金额" align="center">
                        <el-table-column prop="lastYear3Amt" label="同期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column prop="currYear3Amt" label="当期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column  prop="standard3"    label="是否达标"   width="80"      >
                            <template slot-scope="scope">
                                <span :style="{ color: getStandardColor(scope.row.standard3) }">
                                  {{ formatStandard(scope.row.standard3) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reward3" label="奖励金额(元)" width="80" align="right" ></el-table-column>
                    </el-table-column>

                    <el-table-column label="4月安装金额" align="center">
                        <el-table-column prop="lastYear4Amt" label="同期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column prop="currYear4Amt" label="当期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column  prop="standard4"    label="是否达标"   width="80"      >
                            <template slot-scope="scope">
                                <span :style="{ color: getStandardColor(scope.row.standard4) }">
                                  {{ formatStandard(scope.row.standard4) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reward4" label="奖励金额(元)" width="80" align="right" ></el-table-column>
                    </el-table-column>

                    <el-table-column label="5月安装金额" align="center">
                        <el-table-column prop="lastYear5Amt" label="同期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column prop="currYear5Amt" label="当期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column  prop="standard5"    label="是否达标"   width="80"      >
                            <template slot-scope="scope">
                                <span :style="{ color: getStandardColor(scope.row.standard5) }">
                                  {{ formatStandard(scope.row.standard5) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reward5" label="奖励金额" width="80" align="right" ></el-table-column>
                    </el-table-column>


                    <el-table-column label="6月安装金额" align="center">
                        <el-table-column prop="lastYear6Amt" label="同期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column prop="currYear6Amt" label="当期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column  prop="standard6"    label="是否达标"   width="80"      >
                            <template slot-scope="scope">
                                <span :style="{ color: getStandardColor(scope.row.standard6) }">
                                  {{ formatStandard(scope.row.standard6) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reward6" label="奖励金额(元)" width="80" align="right" ></el-table-column>
                    </el-table-column>



                    <el-table-column label="7月安装金额" align="center">
                        <el-table-column prop="lastYear7Amt" label="同期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column prop="currYear7Amt" label="当期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column  prop="standard7"    label="是否达标"   width="80"      >
                            <template slot-scope="scope">
                                <span :style="{ color: getStandardColor(scope.row.standard7) }">
                                  {{ formatStandard(scope.row.standard7) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reward7" label="奖励金额(元)" width="80" align="right" ></el-table-column>
                    </el-table-column>


                    <el-table-column label="8月安装金额" align="center">
                        <el-table-column prop="lastYear8Amt" label="同期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column prop="currYear8Amt" label="当期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column  prop="standard8"    label="是否达标"   width="80"      >
                            <template slot-scope="scope">
                                <span :style="{ color: getStandardColor(scope.row.standard8) }">
                                  {{ formatStandard(scope.row.standard8) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reward8" label="奖励金额(元)" width="80" align="right" ></el-table-column>
                    </el-table-column>


                    <el-table-column label="9月安装金额" align="center">
                        <el-table-column prop="lastYear9Amt" label="同期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column prop="currYear9Amt" label="当期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column  prop="standard9"    label="是否达标"   width="80"      >
                            <template slot-scope="scope">
                                <span :style="{ color: getStandardColor(scope.row.standard9) }">
                                  {{ formatStandard(scope.row.standard9) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reward9" label="奖励金额(元)" width="80" align="right" ></el-table-column>
                    </el-table-column>


                    <el-table-column label="10月安装金额" align="center">
                        <el-table-column prop="lastYear10Amt" label="同期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column prop="currYear10Amt" label="当期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column  prop="standard10"    label="是否达标"   width="80"      >
                            <template slot-scope="scope">
                                <span :style="{ color: getStandardColor(scope.row.standard10) }">
                                  {{ formatStandard(scope.row.standard10) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reward10" label="奖励金额(元)" width="80" align="right" ></el-table-column>
                    </el-table-column>

                    <el-table-column label="11月安装金额" align="center">
                        <el-table-column prop="lastYear11Amt" label="同期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column prop="currYear11Amt" label="当期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column  prop="standard11"    label="是否达标"   width="80"      >
                            <template slot-scope="scope">
                                <span :style="{ color: getStandardColor(scope.row.standard11) }">
                                  {{ formatStandard(scope.row.standard11) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reward11" label="奖励金额(元)" width="80" align="right" ></el-table-column>
                    </el-table-column>

                    <el-table-column label="12月安装金额" align="center">
                        <el-table-column prop="lastYear12Amt" label="同期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column prop="currYear12Amt" label="当期(万元)" width="100" align="right" ></el-table-column>
                        <el-table-column  prop="standard12"    label="是否达标"   width="80"      >
                            <template slot-scope="scope">
                                <span :style="{ color: getStandardColor(scope.row.standard12) }">
                                  {{ formatStandard(scope.row.standard12) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reward12" label="奖励金额(元)" width="80" align="right" ></el-table-column>
                    </el-table-column>

                    <el-table-column prop="jiSuan" label="是否计算返利" width="100">
                        <template slot-scope="scope">
                            <span
                                :style="{ color: scope.row.jiSuan ? '#67C23A' : '#F56C6C' }"
                            >
                            {{ scope.row.jiSuan ? '是' : '否' }}
                            </span>
                        </template>
                    </el-table-column>

                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                         <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel">批量导出
                        </el-button>
                    </div>
                   <div class="h-pagination2">
                        <pagination :page="q" @query="query" />
                    </div>
                </div>

            </div>
        </div>


    </div>
</template>
<script>

import reformService from "../../../api/reform/reformService.js";
import updownfile from "../../../utils/updownfile";
import ss from "../../../api/SystemService";
import engTable from "../../../api/dingd/ProductEngTable";
export default {
    components: {},
    data() {
        return {
            //查询属性
            q: {
                customerLike:null,
                saleareaName:null,
                saleareaCode:null,
                salesCity:null,
                salesCityName:null,
                qudaoList:null,
                year:null,
                jiSuan:null,
                delflag:1,
                pageSize:10,
                pageNo:1,
                total:0,
            },
            salesCityList: [],
            tableSelectedList:[],
            //table列表
            tableData: [],
            countlist:'',
            showhistory: null,
            // 展开折叠筛选
            isScreen: false,

        }
    },
    created() {
        this.query();
        this.queryTotal();
    },
    methods: {
        query() {
            ss.contractService.contractInstallPage(this.q).then(rd=>{
                this.q.total = rd.total;
                this.tableData = rd.records;
            })
        },
        queryTotal() {
            ss.contractService.contractInstallTotal(this.q).then(rd=>{
                this.countlist = rd;
            })
        },

        handleFilter() {
            this.query();
            this.queryTotal();
        },

        handleSelectionChange(lists){
            this.tableSelectedList = lists;
        },
        //重置
        resetData(){
            this.q.customerLike = null;
            this.q.saleareaName = null;
            this.q.saleareaCode = null;
            this.q.salesCity = null;
            this.q.salesCityName = null;
            this.q.qudaoList = null;
            this.q.year = null;
            this.q.jiSuan = null;

        },

        changeArea(query) {
            this.q.salesCity = '';
            var areas = [];
            areas.push(query.refid)
            ss.UserService.getCityByArea(areas).then(rd => {
                console.log(rd);
                this.salesCityList = rd.msg;
            })
        },



        formatDate(row, column) {
            // 获取单元格数据
            let data = row[column.property]
            if(data == null || data == '') {
                return null
            }
            let dt = new Date(data)
            return this.$util.riQi3(dt);
        },
        exportExcel(){

            const { pageSize, pageNo, total, ...exportParams } = this.q;//排除分页参数
            updownfile.down("api/swyl/v1/hetong/bsCcontractXsptInstall/downloadExcel", exportParams, "post");

        },
        formatStandard(value) {
            if (value == null || value === '') {
                return null; // 或 undefined，表示不显示
            }
            return value ? '是' : '否';
        },
        getStandardColor(value) {
            if (value == null || value === '') {
                return '';
            }
            return value ? '#67C23A' : '#F56C6C';
        },


        getSummaries({ columns }) {
            const sums = [];

            // 第1列：序号 → 显示“合计”
            sums.push('合计');

            // 第2~9列：客户相关信息（共8列）
            // saleareaName, salesCityName, cityType, customerCode, customerName,
            // salechannelCode, yewuname, phone
            for (let i = 0; i < 8; i++) {
                sums.push('');
            }

            // 12个月 × 4列：lastYearX, currYearX, standardX, rewardX
            for (let month = 1; month <= 12; month++) {
                // 同期(万元)
                const lastYearVal = this.countlist[`lastYear${month}Amt`] || 0;
                sums.push(Number(lastYearVal).toFixed(2));

                // 当期(万元)
                const currYearVal = this.countlist[`currYear${month}Amt`] || 0;
                sums.push(Number(currYearVal).toFixed(2));

                // 是否达标 → 非数值，留空
                sums.push('');

                // 奖励金额(元)
                const rewardVal = this.countlist[`reward${month}`] || 0;
                sums.push(Number(rewardVal).toFixed(2));
            }

            // 最后一列：是否计算返利 → 留空
            sums.push('');

            return sums;
        }

    }
}
</script>
<style lang="scss">
.el-table .el-table__footer  tbody tr td {
    background-color: #f0f7ff !important;
    font-weight: bold;
    color: #333;
}
</style>
